// Copyright (c) Qualcomm Technologies, Inc. and/or its subsidiaries.
// SPDX-License-Identifier: BSD-3-Clause-Clear

export const sliderClasses = {
  control: "qui-slider__control",
  errorText: "qui-slider__error-text",
  hiddenInput: "qui-slider__hidden-input",
  hint: "qui-slider__hint",
  label: "qui-slider__label",
  marker: "qui-slider__marker",
  markerGroup: "qui-slider__marker-group",
  minMaxMarker: "qui-slider__minMaxMarker",
  range: "qui-slider__range",
  root: "qui-slider__root",
  thumb: "qui-slider__thumb",
  thumbIndicator: "qui-slider__thumb-indicator",
  track: "qui-slider__track",
  valueText: "qui-slider__value-text",
} as const
